module.exports=function(n){return"other"}